import { z } from 'zod';

export const createClientAdminUserSchema = z.object({
  fullName: z.string().trim().min(1, '氏名を入力してください。'),
  email: z
    .string()
    .trim()
    .min(1, 'メールアドレスを入力してください。')
    .email('有効なメールアドレスを入力してください。'),
});

export type CreateClientAdminUserFormFieldValues = z.infer<typeof createClientAdminUserSchema>;
